export interface Toaster {
  type: NotificationType;
  message: string;
  duration?: number;
}

export enum NotificationType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}
